export type IcSkeletonVariants = "rectangle" | "text" | "circle";
